import React from 'react';

import HorizontalNav2 from '../components/horizontal-navs/HorizontalNav2';
import ElementParagraph from '../components/__elements/ElementParagraph';
import Portfolio2 from '../components/portfolio/Portfolio2';
import Team1 from '../components/team/Team1';

export default function Test() {
  return (
    <React.Fragment>
      <HorizontalNav2
        content={{
          brand: {
            text: 'TEST HOUSE',
            image: '',
            width: '110',
          },
        }}
      />

      <ElementParagraph
        content={{
          '02_paragraph': 'teasdqdqwewqe!',
        }}
      />

      <Portfolio2
        content={{
          image1:
            'https://static.shuffle.dev/images/photo-1593642702749-b7d2a804fbcf.jfif',
          image2:
            'https://static.shuffle.dev/images/photo-1611095562057-2e70d5bf9dee.jfif',
        }}
      />

      <Team1 content={null} />
    </React.Fragment>
  );
}

